<template>
<div v-loading="dataLoading" class="alert-detail-wrapper">
  <div v-if="detailsData" class="alert-detail">
    <div class="detail-top">
      <div class="status-title">{{$t('message.tableCommon.status')}}</div>
      <div class="status-step-box">
        <div v-for="(item, index) in stepList" :key="item.value" class="status-step-item">
          <div v-if="index >= currentIndex" class="status-step-dot" :class="{current: currentIndex === index}">{{index + 1}}</div>
          <div v-else class="status-step-dot finished iconfont icon-wancheng-buzhou"></div>
          <div class="status-step-label">{{item.label}}</div>
          <div v-if="index < stepList.length - 1" class="status-step-line"></div>
        </div>
      </div>
    </div>
    <details-component :details-condition="detailCondition">
    </details-component>
  </div>
</div>
</template>
<script>

import DetailsComponent from '@/components/base-details/details.vue';
import { ShowWarningMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { isNullForDisplay } from '@/utils/tools/utils';
import { queryEthocaEnrollmentDetail } from '@/views/risk/api/ethoca';

export default {
  components: {
    DetailsComponent,
  },
  data() {
    return {
      dataLoading: true,
      id: '',
      txnTypeList: [],
      txnStatusList: [],
      detailCondition: [],
      detailsData: null,
      stepList1: [{
        label: this.$t('message.alert.initiateActivation'),
        value: '0',
      }, {
        label: this.$t('message.alert.pendingActivation'),
        value: '1',
      }, {
        label: this.$t('message.alert.activing'),
        value: '2',
      }, {
        label: this.$t('message.alert.actived'),
        value: '3',
      }],
      stepList2: [{
        label: this.$t('message.alert.initiateActivation'),
        value: '0',
      }, {
        label: this.$t('message.alert.pendingActivation'),
        value: '1',
      }, {
        label: this.$t('message.alert.activing'),
        value: '2',
      }, {
        label: this.$t('message.alert.activeFailed'),
        value: '3',
      }],
      stepList3: [{
        label: this.$t('message.alert.initiateClose'),
        value: '0',
      }, {
        label: this.$t('message.alert.pendingClose'),
        value: '1',
      }, {
        label: this.$t('message.alert.closing'),
        value: '2',
      }, {
        label: this.$t('message.alert.closed'),
        value: '3',
      }],
      stepList: [],
      currentIndex: 1,
      preDisputeServiceList: [],
    };
  },
  methods: {
    async initData() {
      this.id = this.$route.query.id;
      const dict = await GlobalData.getDictList(['ACW_ENROLLMENT_STATUS', 'ETHOCA_ACW_PRE_DISPUTE_SERVICE']);
      this.preDisputeServiceList = initSelectedData(dict.ETHOCA_ACW_PRE_DISPUTE_SERVICE);
      await this.initDetailsAll();
    },
    getEnrollmentInfoTemplate(allData) {
      return {
        topTitle: 'message.alert.enrollmentContent',
        type: 'default',
        listTemplate: [
          {
            titleBar: { title: 'message.alert.preDisputeService' },
            key: 'preDisputeService',
            textFunc: (data) => getEnantiomericValue(this.preDisputeServiceList, data.preDisputeService),
          },
          {
            titleBar: { title: 'message.alert.resellerSubMerchantId' },
            key: 'resellerSubMerchantId',
          },
          {
            titleBar: { title: 'message.alert.billDesc' },
            key: 'billDesc',
          },
          {
            titleBar: { title: 'message.alert.note' },
            key: 'notes',
          },
        ],
        data: allData,
      };
    },
    async initDetailsAll() {
      this.dataLoading = true;
      try {
        this.detailCondition.length = 0;
        this.detailCondition.push(this.getEnrollmentInfoTemplate({}));
        const alertInfo = await queryEthocaEnrollmentDetail(this.id);
        const data = {
          ...alertInfo,
        };
        this.detailCondition.length = 0;
        this.detailsData = data;
        this.detailCondition.push(this.getEnrollmentInfoTemplate(data));

        if (alertInfo.enrollmentStatus === 'ENROLLMENT_FAILED') {
          this.stepList = this.stepList2;
        } else if (['SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLING', 'DISENROLLED'].includes(alertInfo.enrollmentStatus)) {
          this.stepList = this.stepList3;
        } else {
          this.stepList = this.stepList1;
        }

        if (['PENDING_SUBMISSION'].includes(alertInfo.enrollmentStatus)) {
          this.currentIndex = 0;
        } else if (['ENROLLING', 'DISENROLLING'].includes(alertInfo.enrollmentStatus)) {
          this.currentIndex = 2;
        } else if (['ENROLLED', 'DISENROLLED', 'ENROLLMENT_FAILED'].includes(alertInfo.enrollmentStatus)) {
          this.currentIndex = 4;
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/variables.scss';

.alert-detail-wrapper {
  min-height: 500px;
}

.alert-detail {
  ::v-deep #details .bd-details-wrap {
    &:first-child {
      border-top: none;
    }
    .el-card__body {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.detail-top {
  margin-bottom: 30px;
  padding-top: 30px;
  .status-title {
    font-weight: 800;
    font-size: 16px;
    color: $color-text-primary;
    line-height: 25px;
    margin-bottom: 20px;
  }
  .status-step-box {
    display: flex;
    align-items: center;

    .status-step-item {
      display: flex;
      align-items: center;
      width: 216px;
      margin-right: 12px;

      .status-step-dot {
        width: 24px;
        height: 24px;
        background-color: $color-border-txn;
        color: $color-text-primary;
        border-radius: 50%;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        &.current {
          background: $color-text-default-button;
          color: white;
        }
        &.finished {
          font-size: 20px;
          background-color: #E8F3FF;
        }
      }

      .status-step-label {
        margin-left: 12px;
        margin-right: 12px;
        font-weight: 500;
        font-size: 14px;
        color: $color-text-primary;
        line-height: 22px;
      }

      .status-step-line {
        flex: 1;
        border-top: 1px solid #E1E3E4;
      }
    }
  }
}
</style>
